import { create } from "zustand";
import { persist } from "zustand/middleware";

interface SettingsState {
  /** When true, hide WildChat-derived sessions and show only spec-generated ones. */
  syntheticOnly: boolean;
  setSyntheticOnly: (v: boolean) => void;
}

export const useSettings = create<SettingsState>()(
  persist(
    (set) => ({
      syntheticOnly: true,
      setSyntheticOnly: (v) => set({ syntheticOnly: v }),
    }),
    // Bumped to -v2 to invalidate any stored copies under the previous
    // default (false). Users get the new default on next page load.
    { name: "monitor-settings-v2" },
  ),
);
